<template>
<div class="card">
  <div class="card-header">
    <h4>Configurações Gerais</h4>
  </div>
  <div class="card-content">
    <div class="form-group">
      <p class="category"><strong>Nome</strong> do Projeto</p>
      <input
        type="text"
        name="name"
        v-validate="modelValidations.name"
        v-model="project.name"
        class="form-control"
      >
      <small
        class="text-danger"
        v-show="modelValidations.name.invalid"
      > {{ getError('name') }}
      </small>
    </div>
    <div class="form-group">
      <p class="category">Endereço do <strong>Cadastro Online</strong> do Projeto</p>
      <input
        type="text"
        name="projectOnlineRegister"
        v-model="project.projectOnlineRegister"
        class="form-control"
      >
    </div>

    <div class="form-group">
      <p class="category">Como será o rótulos na qual os eventos deverão ser chamados dentro do sistema?</p>
      <input
        type="radio"
        name="eventLabel"
        v-model="project.eventLabel"
        value="Eventos"
        required
      >Eventos
      <br>
      <input
        type="radio"
        name="eventLabel"
        v-model="project.eventLabel"
        value="Ações"
        required
      >Ações
    </div>

    <div class="form-group">
      <p class="category">Será exibido o card com os contadores do educacional na Dashboard?</p>
      <YesNoRadio v-model="project.dashboardEduCards"/>
    </div>

    <div class="form-group">
      <p class="category"> Qual o <strong>estado onde</strong> o projeto ocorrerá? Por padrão. </p>
      <select
        @change="changeStateName"
        class="form-control"
        name="project-state"
        id="form-select-proejct-state"
        v-model="project.state"
      >
        <option value="">Selectione um estado...</option>
        <option
          v-for="item in activeStateOptions"
          :value="item.value"
        >{{item.label}}
        </option>
      </select>
      <small
        class="text-danger"
        v-show="modelValidations.state.invalid"
      > {{ getError('state') }}
      </small>
    </div>

    <div class="form-group">
      <p class="category">Neste projeto <strong>poderá haver pesquisa</strong>?</p>
      <YesNoRadio v-model="project.haveSurveys"></YesNoRadio>
    </div>

    <div
      class="form-group"
      v-if="project.haveSurveys"
    >
      <p class="category">Qual a <strong>opção padrão de escolha dos vencedores </strong> do evento?</p>
      <div
        v-for="(value, iterator) in Object.keys(defaultWinnerChoiceModeOptions)"
        :keys="iterator"
      >
        <input
          type="radio"
          name="default-winner-event-choice"
          :value="value"
          v-model="project.defaultWinnerChoiceMode"
        />
        {{defaultWinnerChoiceModeOptions[value]}}
      </div>
    </div>
    <div
      class="form-group"
      v-if="project.haveSurveys"
    >
      <p class="category">Neste projeto <strong>exibirá mapa </strong>?</p>
      <YesNoRadio v-model="project.viewGoogleMap"></YesNoRadio>
    </div>

    <div class="form-group">
      <p class="category">
        A <strong>verificação se o cliente é duplicado</strong> será através de:
      </p>
      <p-checkbox
        name="validationCustomer"
        v-model="project.validationCustomer.uc"
        :checked="modelValidations.validationCustomer.uc"
      >UC
      </p-checkbox>
      <p-checkbox
        name="validationCustomer"
        v-model="project.validationCustomer.cpf"
        :checked="modelValidations.validationCustomer.cpf"
      >CPF
      </p-checkbox>
      <p-checkbox
        name="validationCustomer"
        v-model="project.validationCustomer.ucOrCpf"
        :checked="modelValidations.validationCustomer.ucOrCpf"
      >UC ou CPF
      </p-checkbox>
    </div>
    <div class="form-group">
      <p class="category">
        A verificação de <strong>clientes contemplados</strong>
        será através de:
      </p>
      <p-checkbox
        name="validationContemplatedCustomer"
        v-model="project.validationContemplatedCustomer.uc"
        :checked="modelValidations.validationContemplatedCustomer.uc"
      >UC
      </p-checkbox>
      <p-checkbox
        name="validationContemplatedCustomer"
        v-model="project.validationContemplatedCustomer.cpf"
        :checked="modelValidations.validationContemplatedCustomer.cpf"
      >CPF
      </p-checkbox>
      <small
        class="text-danger"
        v-show="modelValidations.name.invalid"
      >
        {{ getError('validationContemplatedCustomer') }}
      </small>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <div class="form-group">
          <p class="category">
            Será obrigatório o <strong>NIS no cadastro</strong>
            do cliente?
          </p>
          <YesNoRadio v-model="project.requiredNIS"></YesNoRadio>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import YesNoRadio from '../YesNoRadio'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'GeneralConfigProject',

  components: {
    YesNoRadio
  },

  computed: {
    project: {
      get () {
        return this.$store.state.project.one
      }
    },
    ...mapGetters('project', {
      haveSurveys: 'haveSurveys',
      model: 'model',
      modelValidations: 'validations',
      termsByState: 'termsByState',
      defaultWinnerChoiceModeOptions: 'defaultWinnerChoiceModeOptions'
    }),
    ...mapGetters('states', ['activeStateOptions', 'statesOptions']),
    activeStateOptions: function () {
      return this.statesOptions.filter(item => {
        return Object.keys(this.termsByState).indexOf(item.value) >= 0
      })
    }
  },

  methods: {
    ...mapActions('states', { fetchStates: 'fetchAll', setCities: 'setCities' }),
    getError (fieldName) {
      return this.errors.first(fieldName)
    },
    async changeStateName () {
      const state = await this.getState()
      if (state && state.length > 0) {
        this.setCities(state[0].cidades)
        this.project.cities = state[0].cidades
        this.project.company.address.state = state[0].nome
      }
    },
    getState () {
      return this.fetchStates({ where: { 'sigla': this.project.state }, limit: 1, noCommit: true })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Trg/Project/GeneralConfigProject.vue